import { useCallback } from "react";

import { storeApi, useAppSelector } from "store/index";
import {
  selectCurrentClassUserId,
  selectCurrentCourseId,
  selectCurrentCourseUserId,
  selectCurrentUserId,
} from "store/selectors";

export const useJoinAsCourseAdmin = () => {
  const currentCourseUserId = useAppSelector(selectCurrentCourseUserId);
  const currentUserId = useAppSelector(selectCurrentUserId);
  const currentCourseId = useAppSelector(selectCurrentCourseId);
  const currentClassUserId = useAppSelector(selectCurrentClassUserId);

  const joinAsCourseAdminIfNew = useCallback(async () => {
    let courseUserId = currentCourseUserId;
    let classUserId = currentClassUserId;

    if (!currentCourseUserId) {
      courseUserId = (
        await storeApi.course_users.create({
          section_id: currentCourseId!,
          user_id: currentUserId!,
          role: "course_admin",
        })
      )?.id;

      classUserId = (
        await storeApi.class_users.create({
          section_id: currentCourseId!,
          section_user_id: courseUserId,
        })
      )?.id;
    }

    return { courseUserId: courseUserId!, classUserId: classUserId! };
  }, [currentCourseUserId, currentCourseId, currentUserId, currentClassUserId]);

  return { joinAsCourseAdminIfNew };
};
